(function ($) {
    'use strict';

    $(function () {
        const $modal = $('.js-modal');
        const $close = $('.js-modal-close');
        const $items = $('.js-modal-options-item');
        const activeBodyClass = 'modal-active';
        const activeClass = 'is-active';

        if (!$modal.length > 0) {
            return;
        }

        function showModal() {
            $('body').addClass(activeBodyClass);
            $modal.addClass(activeClass);
        }

        function hideModal() {
            $('body').removeClass(activeBodyClass);
            $modal.removeClass(activeClass);
        }

        function switchToStateTab(state) {
            const $trigger = $('.js-tab-group-trigger');
            const $target = $('.js-tab-group-target');
            const filteredTrigger = $trigger.filter(`[data-state="${state}"]`);
            const filteredTarget = $target.filter(`[data-state="${state}"]`);

            $trigger.each(function () {
                $(this).removeClass(activeClass).attr('aria-expanded', false);
            });

            $target.each(function () {
                $(this).removeClass(activeClass);
            });

            // Set the first tab to active if the selected tab is not found
            if (filteredTrigger.length === 0) {
                $trigger.first().addClass(activeClass).attr('aria-expanded', true);
                $target.first().addClass(activeClass);
            } else {
                filteredTrigger.addClass(activeClass).attr('aria-expanded', true);
                filteredTarget.addClass(activeClass);
            }
        }

        $close.on('click', hideModal);

        $items.on('click', function (e) {
            e.preventDefault();

            const state = $(this).data('state');

            setStateCookie(state);
            switchToStateTab(state);

            hideModal();
        });

        // If we already have a saved state, switch to that tab
        const savedState = getStateCookie();

        if (savedState) {
            switchToStateTab(savedState);
        } else {
            showModal();
        }
    });
})(jQuery);
